import { Inject, Injectable, forwardRef} from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';

import  { Observable } from 'rxjs/Observable';

import { HttpClient } from './http-client.service';

import { TranslationCategory } from '../../entities/translation-category';

import { Settings } from '../../settings';

import { DateConverter } from '../../utility/date-converter';

import { ODataBuilder } from '../../utility/odata/odata-builder';
import { ODataComparer } from '../../utility/odata/odata-comparer';

import { CachedCallService } from './cached-call.service';

@Injectable()
export class TranslationCategoryService {
  private readonly headers:Headers = new Headers({ 'Content-Type': 'application/json' });
  private readonly options:RequestOptions = new RequestOptions({ headers: this.headers });

  private static readonly translationCategoryBaseUrl:string = `${Settings.apiUrl}/v1/TranslationCategories`;

  protected cachedCallService:CachedCallService = new CachedCallService();

  public translationCategories:TranslationCategory[] = [];

  constructor(@Inject(forwardRef(() => HttpClient)) private http:HttpClient) { }

  getPageTranslationCategories(): Promise<TranslationCategory[]> {

    let oDataBuilder: ODataBuilder = new ODataBuilder(TranslationCategoryService.translationCategoryBaseUrl);

    oDataBuilder
      .filter("IsPage", ODataComparer.Equals, true)
      .orderBy("SortOrder");

    let translationCategoryUrl: string = oDataBuilder.toString();

    return this.http.get(translationCategoryUrl)
      .toPromise()
      .then(response => {
        return response.json().value;
      });

  }

} 



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/ng-router-loader?{"loader":"async-system","genDir":"compiled","aot":false}!./src/app/services/http/translation-category.service.ts